/**
 * The line-items table's column labels, in order — the one thing both apps' otherwise
 * independent tables must genuinely agree on. Each app still renders its own markup
 * (the grid track widths and the UI kit differ between the consultant app and the client
 * portal, legitimately); only the columns themselves, and their order, are shared.
 *
 * Deliberately data rather than a shared component: this package is React-free by design
 * (see index.ts's header), and the duplication worth removing here was the column list,
 * not the markup around it.
 */
export const LINE_ITEM_COLUMN_LABELS = [
  "Description",
  "Qty",
  "Unit",
  "Unit price",
  "VAT",
] as const;
